import React, { useContext } from 'react';
import { Badge, Popover, List, Empty, Button } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useNotificacion } from '../context/notificacionContext';
import { useNavigate } from 'react-router-dom';

const NotificacionesBadge = () => {
  const { notificaciones, limpiarNotificaciones } = useNotificacion();
  const navigate = useNavigate();

  const contenido = (
    <div style={{ width: 300, maxHeight: 400, overflowY: 'auto' }}>
      {notificaciones.length === 0 ? (
        <Empty description="No hay notificaciones" style={{ padding: '20px 0' }} />
      ) : (
        <>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            padding: '8px 0',
            borderBottom: '1px solid #f0f0f0',
            marginBottom: 8
          }}>
            <span style={{ fontWeight: 'bold' }}>Notificaciones</span>
            <Button 
              type="link" 
              size="small" 
              onClick={limpiarNotificaciones}
              style={{ padding: 0 }}
            >
              Limpiar
            </Button>
          </div>
          <List
            dataSource={notificaciones}
            renderItem={(item) => (
              <List.Item
                style={{ 
                  cursor: 'pointer',
                  padding: '12px',
                  borderBottom: '1px solid #f0f0f0'
                }}
                onClick={() => {
                  navigate('/pedidos-cliente');
                }}
              >
                <List.Item.Meta
                  title={
                    <div style={{ fontSize: '13px', fontWeight: 500 }}>
                      Pedido #{item.pedidoId}
                    </div>
                  }
                  description={
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      {item.mensaje || `Estado: ${item.estadoNombre}`}
                      <div style={{ fontSize: '11px', color: '#999', marginTop: 4 }}>
                        {new Date(item.timestamp).toLocaleString('es-AR')}
                      </div>
                    </div>
                  }
                />
              </List.Item>
            )}
          />
        </>
      )}
    </div>
  );

  return (
    <Popover 
      content={contenido} 
      title={null}
      placement="bottomRight"
      trigger="click"
    >
      <Badge count={notificaciones.length} size="small">
        <BellOutlined style={{ fontSize: 20, color: '#fff', cursor: 'pointer' }} />
      </Badge>
    </Popover>
  );
};

export default NotificacionesBadge;
